{
    "ReporttypeDesktopwallboard": "Desktop-Wallboard (nicht lizenziert)",
    "ReporttypeDashboard": "Armaturenbrett",
    "ReporttypeActivecalllist": "Aktive Anrufliste (nicht lizenziert)",
    "ReporttypeHistoriccalllist": "Historische Anrufliste",
    "ReporttypeUnreturnedlostcalls": "Nicht zurückgegebene verlorene Anrufe (nicht lizenziert)",
    "ReporttypeExtensionlist": "Erweiterungsliste (nicht lizenziert)",
    "ReporttypeAcdagentlist": "ACD-Agentenliste (nicht lizenziert)",
    "ReporttypeHuntgrouplist": "Sammelanschlussliste (nicht lizenziert)",
    "ReporttypeTrunkinterfacelist": "Trunk-Schnittstellenliste",
    "ReporttypeCallsbytelno": "Anrufe unter Tel.Nr",
    "ReporttypeCallsbyddi": "Anrufe über DDI (nicht lizenziert)",
    "ReporttypeCallsbyhalfhourinterval": "Anrufe im ½-Stunden-Intervall",
    "ReporttypeCallsbyhalfhourplusday": "Anrufe bis ½ Stunde + Tag",
    "ReporttypeCallsbyday": "Anrufe am Tag",
    "ReporttypeCallsbyweek": "Anrufe pro Woche",
    "ReporttypeCallsbymonth": "Anrufe nach Monat",
    "ReporttypeCallsbyaccountcode": "Anrufe nach Kontocode (nicht lizenziert)",
    "ReporttypeAcddndactivitylog": "ACD \/ DND-Aktivitätsprotokoll (nicht lizenziert)",
    "ReporttypeAcsnacodeusage": "ACS N\/A Codenutzung (nicht lizenziert)",
    "ReporttypeExternalcontent": "Externer Inhalt (über URL)",
    "ReporttypeUnlicensedformattingstring": "|1 (Nicht lizenziert)",
    "GroupLive": "Live-Events",
    "GroupEntity": "Einheit",
    "GroupLogs": "Protokolle",
    "GroupInterval": "Intervall",
    "GroupMisc": "Sonstig",
    "NAME": "ReportTypes"
}